import { create } from "zustand";
import jwt from "jwt-decode";
import useShopStore from "./useShopStore";
import useAppStore from "./useAppStore";
import sendRequest from "./send-request";

const API_URL = "https://nightdrinkas.onrender.com/api/user/";
// const API_URL = "http://localhost:8000/api/user/";
const SECONDS_TO_RELOGIN = 30;
const initialState = {
  token: null,
  decodedToken: null,
  user: null,
  dataLogin: null,

  signup: {
    success: false,
  },
};

const store = (set, get) => ({
  ...initialState,
  userResetAll: () => set({ ...initialState }),

  /* 

  GET-->
  Logog on refres -- Checks if there is token saved and then it will be tested
  if its less then EXP time of token if every thing match it will try to
  get data from Local storages where this token lives will try to logIn
  */
  userCheckToken: async () => {
    try {
      if (get().user) {
        if (get().decodedToken.exp - +new Date() / 1000 < SECONDS_TO_RELOGIN) {
          if (get().dataLogin) {
            return get().userLogin(get().dataLogin);
          }
          return get().userLogout();
        }
        return;
      }

      // token von local storage lesen
      const token = localStorage.getItem("token");
      if (!token) return;

      // Token dekodieren
      const decodedToken = jwt(token);

      // Stammdaten des angemeldeten Benutzers holen
      const response = await sendRequest({
        url: `${API_URL}/${decodedToken.id}`,
      });

      // TODO: Fehlerbehandlung
      if (response.status !== 200) {
        return "ERROR";
      }

      const user = response.data.data;

      set({ token, decodedToken, user });
      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: { name: error.name, message: error.message },
        success: false,
      });
    }

    // wenn user object vorhanden ist dann prüfen, ob der Token noch gültig ist
  },

  /* 
  POSt -->
  USER LOG IN Form Data will be sent as data 
  */
  login: async (data) => {
    try {
      let response = await sendRequest({
        url: `${API_URL}sign-in`,
        data,
        method: "POST",
      });
      console.log(response.data.message);

      if (response.data.message === "sucess") {
        console.log("setting seucess");
        useAppStore.setState({ isLogin: true });
      }
      /* Setting Error in AppStore  if Message is Error*/
      if (response.data.message === "error") {
        const { errorName } = response?.data;
        useAppStore.setState({
          success: false,
          isLogin: false,
          errorName,
        });
      }

      const token = response.data.data;
      // // Token in localStorage ablegen
      localStorage.setItem("token", token);

      const decodedToken = jwt(token);

      response = await sendRequest({
        url: `${API_URL}/${decodedToken.id}`,
      });

      const user = response.data.data;

      // Daten in Store eintragen
      set({ token, decodedToken, user, dataLogin: data });
    } catch (error) {
      useAppStore.setState({
        errors: { name: error.name, message: error.message },
        success: false,
      });
    }
  },

  /* 
  POST --->
  Sign Up user Data will be Sent as Data and will be tested at backend 
  */
  createUser: async (data) => {
    try {
      let response = await sendRequest({
        url: `${API_URL}sign-up`,
        data,
        method: "POST",
      });
      /* IF the responce from Backend is with Sucsses */
      if (response.data.message === "sucess") {
        useAppStore.setState({
          success: true,
          userCreated: true,
        });
      }

      /* Setting Error in AppStore  if Message is Error*/
      if (response.data.message === "error") {
        const { errorName } = response?.data;
        useAppStore.setState({
          success: false,
          userCreated: false,
          errorName,
        });
      }
    } catch (error) {
      /* iF there is Exios erro in which case it can not reach backend */
      useAppStore.setState({
        errors: { name: error.name, message: error.message },
        success: false,
      });
    }
  },

  // Logout
  userLogout: () => {
    // localStorage löschen
    localStorage.removeItem("token");

    // Daten auf null setzen
    set({ token: null, user: null, decodedToken: null });
    useShopStore.setState({ cart: null });
  },
});

const useUserStore = create(store);
export default useUserStore;
